import { Theme } from "@bluframe/blublocks"
import styled from "styled-components"

export const Wrapper = styled.div`
  background-color: ${({ theme }: { theme: Theme }) =>
    theme.palette.text.contrast};
  border-radius: 4px;
  box-shadow:
    0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
`

export const Actions = styled.div`
  column-gap: 10px;
  display: grid;
  justify-items: start;
  padding: 20px;
  row-gap: 10px;
`
